import React from "react";

function UserIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Layer_1" clip-path="url(#clip0_12075_135925)">
        <path
          id="Vector"
          d="M23.4648 17.475C23.4648 16.735 22.8548 16.125 22.0948 16.085H21.3648V14.365C21.3448 13.565 20.7748 12.965 20.0048 12.925C19.3748 12.895 18.7348 12.905 18.1148 12.915H17.8048C17.5648 12.915 17.3948 13.085 17.3948 13.315C17.3948 13.525 17.5548 13.695 17.7848 13.715C17.8448 13.725 17.9048 13.725 17.9548 13.725H19.8848C20.2848 13.725 20.5548 13.985 20.5648 14.365C20.5748 14.735 20.5648 15.095 20.5648 15.475V16.085H18.6448C18.2548 16.085 17.8748 16.075 17.4948 16.075C16.9048 16.075 16.3148 16.085 15.7248 16.085C14.8848 16.095 14.2448 16.695 14.2348 17.485C14.2248 18.975 14.2248 20.435 14.2348 21.815C14.2448 22.565 14.8848 23.205 15.6348 23.205C17.7348 23.225 19.9048 23.225 22.0648 23.205C22.8248 23.205 23.4548 22.585 23.4648 21.825C23.4848 20.445 23.4848 18.975 23.4648 17.475ZM22.6748 21.595C22.6748 22.175 22.4348 22.405 21.8548 22.415H17.3448C16.8448 22.415 16.3548 22.415 15.8548 22.405C15.2648 22.405 15.0348 22.175 15.0348 21.585V17.695C15.0348 17.115 15.2748 16.875 15.8648 16.875H21.8548C22.4348 16.875 22.6748 17.115 22.6748 17.705V21.595Z"
          fill="currentColor"
        />
        <path
          id="Vector_2"
          d="M10.6148 0.784973H10.5748C9.21481 0.784973 7.9348 1.30497 6.9648 2.26497C5.9848 3.23497 5.4348 4.51497 5.4248 5.89497C5.4248 7.27497 5.9548 8.57497 6.9148 9.55497C7.8848 10.535 9.1848 11.075 10.5648 11.075H10.5948C13.4148 11.075 15.7148 8.79497 15.7348 5.96497C15.7548 3.12497 13.4548 0.804973 10.6148 0.784973ZM10.6048 10.275H10.5848C8.1948 10.275 6.2448 8.33497 6.2348 5.94497C6.2348 4.78497 6.6848 3.68497 7.5048 2.86497C8.3248 2.03497 9.41481 1.58497 10.5748 1.57497H10.5848C11.7348 1.57497 12.8248 2.02497 13.6448 2.84497C14.4648 3.66497 14.9148 4.76497 14.9148 5.92497C14.9248 8.31497 12.9848 10.265 10.6048 10.275Z"
          fill="currentColor"
        />
        <path
          id="Vector_3"
          d="M13.4549 13.965C13.4249 14.205 13.2249 14.345 12.9649 14.315C11.5549 14.145 10.2949 14.105 9.11486 14.195C6.49486 14.385 3.99486 15.095 1.66486 16.315C1.43486 16.435 1.31486 16.625 1.31486 16.895V18.395C1.31486 19.135 1.31486 19.885 1.32486 20.635C1.32486 20.965 1.45486 21.355 2.08486 21.355H10.8349C11.1549 21.355 11.3449 21.515 11.3449 21.755C11.3449 21.995 11.1549 22.155 10.8349 22.155C9.73486 22.165 8.62486 22.165 7.51486 22.165H6.40486C5.98486 22.165 5.55486 22.155 5.12486 22.155C4.14486 22.155 3.12486 22.145 2.13486 22.165C1.67486 22.175 1.24486 22.015 0.954857 21.715C0.654857 21.415 0.494857 20.995 0.514857 20.545C0.544857 19.535 0.534857 18.515 0.524857 17.525V16.955C0.514857 16.305 0.784857 15.865 1.36486 15.555C3.54486 14.425 5.87486 13.725 8.29486 13.455C8.99486 13.385 9.70486 13.345 10.4249 13.345C11.2949 13.345 12.1649 13.405 13.0349 13.515C13.3149 13.555 13.4749 13.735 13.4549 13.965Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_12075_135925">
          <rect
            width="22.97"
            height="22.43"
            fill="white"
            transform="translate(0.514893 0.784973)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default UserIcon;
